import { useEffect, useMemo, useState } from 'react';

import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';
import convertErrors from '../utils/convertErrors';
import {
  makeRequiredFieldsValidator,
  useFormState,
  useFormValidation,
} from '../../../hocs/useFormWithValidation';

const addressForm = {
  [PROFILE_FIELDS_TYPES.ADDRESS_1]: '',
  [PROFILE_FIELDS_TYPES.ADDRESS_2]: '',
  [PROFILE_FIELDS_TYPES.CITY]: '',
  [PROFILE_FIELDS_TYPES.STATE]: '',
  [PROFILE_FIELDS_TYPES.COUNTRY]: '',
  [PROFILE_FIELDS_TYPES.POSTAL_CODE]: '',
};

export const validateRequiredFields = (isZipApplicable = true) =>
  makeRequiredFieldsValidator([
    PROFILE_FIELDS_TYPES.CITY,
    PROFILE_FIELDS_TYPES.STATE,
    ...(isZipApplicable && [PROFILE_FIELDS_TYPES.POSTAL_CODE]),
  ]);

export function usePatientAddressFormState(data, errors, isZipApplicable) {
  const { formState, handleFormChange } = useFormState({
    ...addressForm,
    ...data,
  });

  const {
    validateErrors,
    clearErrors,
    addLocalValidateErrors,
  } = useFormValidation(errors);

  const isValid = validateRequiredFields(isZipApplicable)(formState);

  const setCountryValue = value =>
    handleFormChange({
      ...formState,
      [PROFILE_FIELDS_TYPES.COUNTRY]: value,
      [PROFILE_FIELDS_TYPES.STATE]: '',
      [PROFILE_FIELDS_TYPES.POSTAL_CODE]: '',
    });

  const clearPatientForm = () =>
    handleFormChange({
      ...formState,
      [PROFILE_FIELDS_TYPES.ADDRESS_1]: '',
      [PROFILE_FIELDS_TYPES.ADDRESS_2]: '',
      [PROFILE_FIELDS_TYPES.POSTAL_CODE]: '',
      [PROFILE_FIELDS_TYPES.CITY]: '',
    });

  return useMemo(
    () => ({
      formState,
      handleFormChange,
      validateErrors,
      addLocalValidateErrors,
      setCountryValue,
      clearErrors,
      isValid,
      clearPatientForm,
    }),
    [
      formState,
      handleFormChange,
      validateErrors,
      addLocalValidateErrors,
      setCountryValue,
      clearErrors,
      isValid,
      clearPatientForm,
    ],
  );
}

export function usePatientValidation(dataValidationErrors) {
  const [validateErrors, setValidateErrors] = useState({});

  useEffect(() => {
    if (dataValidationErrors) {
      setValidateErrors(convertErrors(dataValidationErrors));
    }
  }, [dataValidationErrors]);

  function clearErrors() {
    setValidateErrors({});
  }

  return { validateErrors, clearErrors };
}

const requiredFields = [
  PROFILE_FIELDS_TYPES.CITY,
  PROFILE_FIELDS_TYPES.STATE,
  PROFILE_FIELDS_TYPES.POSTAL_CODE,
  PROFILE_FIELDS_TYPES.COUNTRY,
];

export const PATIENT_ADDRESS_FIELDS = [
  ...requiredFields,
  PROFILE_FIELDS_TYPES.ADDRESS_1,
  PROFILE_FIELDS_TYPES.ADDRESS_2,
];



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/PatientRegistrationAddress/usePatientAddressForm.jsx